<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Notificações</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <div v-if="firstLoading"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-else>

      <div class="ui segment" v-for="notification in notifications">

        <div class="ui relaxed list">
          <div class="item">
            <i class="large middle aligned icon" :class="notification.icon + ' ' + notification.iconColor"></i>
            <div class="content">
              <h3 class="ui header">
                {{ notification.eventName }}
                <span v-if="!notification.dateDisplay" class="ui mini label"><i class="star icon"></i>Nova</span>  
              </h3>
              <div class="grey text" style="font-size: 12px !important;">
                <i class="calendar icon"></i>{{ formatDate(notification.date) }}
                <span class="m-l-20"><i class="clock icon"></i>{{ notification.time }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="ui divider"></div>

        <span v-html="notification.message" />

      </div>

      <button v-if="showLoadButton" class="ui icon small button" :class="{ loading }" @click="loadNotifications()">
        <i class="ellipsis horizontal icon"></i> Mais notificações
      </button>  

    </div>

  </div>

</template>

<script>

  import NotificationService from "@/services/notification-service"
  import moment from "@/utils/moment"

  const MAX_REGS = 5

  export default {
    
    data() {
      return {
        firstLoading: true,
        loading: true,
        notifications: [],
        lastId: "",
        showLoadButton: true,
      }
    },      

    created() {

      this.loadNotifications()      
    },

    methods: {

      formatDate(date) {
        return moment(date).format("DD/MM/YYYY")
      },

      async loadNotifications() {

        this.loading = true
        
        try {          

          const response = await NotificationService.find({
            showDisplayed: true,
            setDisplayed: true,
            lastId: this.lastId,
            maxRegs: MAX_REGS,            
          })

          response.notifications.forEach((notification) => {
            this.notifications.push(notification)
            this.lastId = notification.id
          })

          this.loading = false
          this.firstLoading = false
          this.showLoadButton = (response.notifications.length >= MAX_REGS)

          this.$store.commit("setUpdateNotifications", true)
          
        } catch (error) {
          
          this.loading = false
          this.firstLoading = false
          this.$errorHandler(error)
        }

      },
    },
  }

</script>

